import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createPlanService",
    serviceName: "shared",
    query: gql`
      mutation createPlanService(
        $plan_id: String!
        $lab_id: String
        $unit_id: String
        $doctor_id: String
        $doctor_ids: [String]
        $lab_ids: [String]
        $unit_ids: [String]
        $details: String
        $servant: String
      ) {
        createPlanService(
          plan_id: $plan_id
          lab_id: $lab_id
          unit_id: $unit_id
          doctor_id: $doctor_id
          doctor_ids: $doctor_ids
          lab_ids: $lab_ids
          unit_ids: $unit_ids
          details: $details
          servant: $servant
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
